export default __webpack_public_path__ + "static/media/golf-clubs.2eac04df.jpg";